var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:{ active: _vm.isActive(_vm.tab) },attrs:{"to":_vm.route}},[_vm._v("\n  "+_vm._s(_vm.tab.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }